import React from "react";
import {
    Box, Stack, Typography, IconButton, Divider,
    Chip, Table, TableHead, TableRow, TableCell,
    TableBody, Dialog, DialogTitle, DialogContent
} from "@mui/material";
import {IconX} from "@tabler/icons-react";

const ToolModal = ({tool, open, onClose}) => {
    if (!tool) return null;
    const props = tool.inputSchema?.properties || {};
    const required = tool.inputSchema?.required || [];
    const paramKeys = Object.keys(props);

    return (
        <Dialog tool={tool} open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>
                <Stack direction="row" alignItems="center" justifyContent="space-between">
                    <Stack gap={0.5}>
                        <Typography fontSize={14} fontWeight={700}>{tool.name}</Typography>
                        <Typography fontSize={12} color="text.secondary">{tool.description}</Typography>
                    </Stack>
                    <IconButton size="small" onClick={onClose}>
                        <IconX size={16}/>
                    </IconButton>
                </Stack>
            </DialogTitle>

            <Divider/>

            <DialogContent>
                <Stack gap={2}>
                    <Typography fontSize={12} fontWeight={700} color="text.secondary">PARAMETERS</Typography>

                    {paramKeys.length === 0 ? (
                        <Typography fontSize={12} color="text.disabled" fontStyle="italic">No parameters</Typography>
                    ) : (
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{fontWeight: 700, fontSize: 11}}>Name</TableCell>
                                    <TableCell sx={{fontWeight: 700, fontSize: 11}}>Type</TableCell>
                                    <TableCell sx={{fontWeight: 700, fontSize: 11}}>Required</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {paramKeys.map(key => (
                                    <TableRow key={key}>
                                        <TableCell sx={{fontSize: 12}}>{key}</TableCell>
                                        <TableCell>
                                            <Chip label={props[key].type || "any"} size="small" sx={{fontSize: 10, height: 18}}/>
                                        </TableCell>
                                        <TableCell>
                                            {required.includes(key) ? (
                                                <Chip label="required" size="small" color="warning" sx={{fontSize: 10, height: 18}}/>
                                            ) : (
                                                <Typography fontSize={11} color="text.disabled">—</Typography>
                                            )}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    )}

                    <Divider/>

                    <Typography fontSize={12} fontWeight={700} color="text.secondary">JSON SCHEMA</Typography>
                    <Box sx={{bgcolor: "grey.100", borderRadius: 2, p: 1.5, overflowX: "auto"}}>
                        <Typography fontSize={11} fontFamily="monospace" component="pre" sx={{m: 0}}>
                            {JSON.stringify(tool.inputSchema, null, 2)}
                        </Typography>
                    </Box>
                </Stack>
            </DialogContent>
        </Dialog>
    );
};

export default ToolModal;